var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",{"type":"text/css"})),React.createElement("path",{"d":"M512 42.666667C252.789333 42.666667 42.666667 252.8 42.666667 512c0 259.210667 210.122667 469.333333 469.333333 469.333333s469.333333-210.122667 469.333333-469.333333C981.333333 252.8 771.210667 42.666667 512 42.666667z m0 853.333333c-212.074667 0-384-171.914667-384-384 0-212.074667 171.925333-384 384-384s384 171.925333 384 384c0 212.085333-171.925333 384-384 384z m158.165333-286.165333a42.666667 42.666667 0 0 1-60.330666 60.341333l-128-128A42.666667 42.666667 0 0 1 469.333333 512V256a42.666667 42.666667 0 0 1 85.333334 0v238.336l115.498666 115.498667z","key":1})]);
}

Clock.defaultProps = {"t":"1536133333907","className":"icon","style":{},"viewBox":"0 0 1024 1024","version":"1.1","width":"20px","height":"16px"};

module.exports = Clock;

Clock.default = Clock;
